import useMuiMediaQuery from '@material-ui/core/useMediaQuery';

export interface MuiMediaQueryListEvent {
    matches: boolean;
}

export type MuiMediaQueryListListener = (event: MuiMediaQueryListEvent) => void;

export interface MuiMediaQueryList {
    matches: boolean;
    addListener: (listener: MuiMediaQueryListListener) => void;
    removeListener: (listener: MuiMediaQueryListListener) => void;
}

export interface Options {
    defaultMatches?: boolean;
    noSsr?: boolean;
    ssrMatchMedia?: (query: string) => MuiMediaQueryList;
}

const MEDIA_ALIAS = {
    mobile: '(max-width: 599px)',
    minMobile: '(min-width: 600px)',
    'max-960': '(max-width: 959px)',
};

export const useMediaQuery = (query: keyof typeof MEDIA_ALIAS | string, options: Options = {}) =>
    useMuiMediaQuery(MEDIA_ALIAS[query] || query, options);
